module.exports = __webpack_public_path__ + "static/media/tgi-fridays.86085cbd.svg";